import styled from 'styled-components';
import { font, color, query, space } from '@design/templateFns';

export const Wrapper = styled.div<{ $reverse?: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${space('x8')};

  @media screen and (${query.atLeast('desktop')}) {
    gap: ${space('x8')};
    grid-template-columns: 1fr 1fr;
    margin: 0 auto;
  }

  @media screen and (${query.atLeast('max')}) {
    gap: ${space('x12')};
  }

  // reverse the order of the grid items

  @media screen and (${query.atLeast('desktop')}) {
    > div:nth-child(2) {
      order: ${({ $reverse }) => ($reverse ? 'inherit' : -1)};
    }
  }
`;

export const ImageWrapper = styled.div``;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Eyebrow = styled.h2`
  ${font('eyebrow-sm')};
  color: ${color('cta')};
  text-transform: uppercase;
  padding-bottom: 0;
  margin-bottom: ${space('lg')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('eyebrow-md')};
  }
`;

export const Headline = styled.h1`
  ${font('headline-sm')};
  padding: 0;
  margin-bottom: ${space('x7')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-md')};
  }
`;

export const Description = styled.div`
  ${font('body-md-light')};
  margin-bottom: ${space('x7')};

  p:last-child {
    // this is rich text, so padding of last child should not affect the margin
    margin-bottom: 0;
    padding-bottom: 0;
  }

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-lg-light')};
    margin-bottom: ${space('x8')};
  }
`;

export const MetaWrapper = styled.div`
  margin-bottom: ${space('x6')};

  @media screen and (${query.atLeast('desktop')}) {
    margin-bottom: ${space('x8')};
  }
`;

export const Author = styled.div`
  ${font('subhead-xs')};
  color: ${color('gray4')};
  padding: 0;
  margin-bottom: ${space('md')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('subhead-sm')};
    margin-bottom: ${space('lg')};
  }
`;

export const Date = styled.div`
  ${font('eyebrow-sm')};
  text-transform: uppercase;
  color: ${color('gray4')};
  margin-bottom: 0;
  padding: 0;
`;

export const CTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${space('x5')};

  @media screen and (${query.atLeast('desktop')}) {
    flex-direction: row;
    align-items: center;
    column-gap: ${space('xl')};
  }

  @media screen and (${query.atLeast('max')}) {
    column-gap: ${space('x5')};
  }

  > button {
    @media screen and (${query.below('desktop')}) {
      margin-bottom: ${space('x5')};
    }
  }
`;

export const CTAWrapperArticle = styled(CTAWrapper)`
  margin-top: auto;
`;

export const ShareWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ShareText = styled.h3`
  ${font('eyebrow-sm')};
  text-transform: uppercase;
  line-height: ${space('xl')}; // to match height of share icons
  color: ${color('gray4')};
  margin-right: ${space('lg')};
  padding: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('eyebrow-md')};
    line-height: ${space('xl')}; // to match height of share icons
  }
`;
